var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isScrolled)?_c('v-btn',{staticClass:"mx-2 scroll-top",attrs:{"title":"Scroll To Top","fab":"","dark":"","color":"#bf360c"},on:{"click":_vm.scrollToTop}},[_c('v-icon',[_vm._v("mdi-arrow-up-circle")])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }